import { Action } from '@ngrx/store';
import { DeviceTypeCRUDInterface } from '../../../shared/component/filter/filter.class';
import { FilterConditionInterface, HttpOptionInterface } from '../filter.model';
import { ApiServer } from '../../../shared/component/filter/dropdown/dropdown.model';

export enum FilterDeviceTypeActionTypes {
  StartLoadFilterDeviceTypes = '[Filter Device Type] Load Filter Device Types',
  FilterDeviceTypesLoaded = '[Filter Device Type] Filter Device Types Loaded',
}

export class StartLoadFilterDeviceTypes implements Action {
  readonly type = FilterDeviceTypeActionTypes.StartLoadFilterDeviceTypes;
  constructor(
    public options: HttpOptionInterface,
    public server: ApiServer = ApiServer.NestJS,
  ) {}
}
export class FilterDeviceTypesLoaded implements Action {
  readonly type = FilterDeviceTypeActionTypes.FilterDeviceTypesLoaded;
  constructor(public data: DeviceTypeCRUDInterface[]) {}
}

export type FilterDeviceTypeActions = StartLoadFilterDeviceTypes | FilterDeviceTypesLoaded;
